<template>
  <div>
    <h2 class="mb-4">Agregar Plantas al Lote</h2>

    <!-- Formulario para agregar plantas -->
    <form @submit.prevent="agregarPlantas" class="row g-3">
      <!-- Primera fila -->
      <!-- Variedad genética con botón y descripción -->
      <div class="col-md-6">
        <label for="variedad" class="form-label">Genética:</label>
        <div class="input-group">
          <select v-model="variedad_id" class="form-select" required>
            <option disabled value="">Seleccione una genética</option>
            <option v-for="variedad in variedades" :key="variedad.id" :value="variedad.id">
              {{ variedad.nombre }} (THC:{{ variedad.thc }}% CBD: {{ variedad.cbd }}%)
            </option>
          </select>
          <button class="btn btn-outline-success" @click="mostrarModalGenetica = true">
            <font-awesome-icon icon="plus" class="me-1" /> Crear Nueva Genética
          </button>


        </div>
        <div class="form-text">Seleccione la genética de las plantas a ingresar.</div>
      </div>

      <!-- Cantidad -->
      <div class="col-md-6">
        <label for="cantidad" class="form-label">Cantidad:</label>
        <input type="number" v-model="cantidad" min="1" class="form-control" required>
        <div class="form-text">Número total de plantas que desea registrar.</div>
      </div>

      <!-- Origen -->
      <div class="col-md-6">
        <label for="origen" class="form-label">Origen de la Planta:</label>
        <select v-model="origen" id="origen" class="form-select" required>
          <option value="" disabled>Seleccione un origen</option>
          <option v-for="(origenItem, index) in origenes" :key="index" :value="origenItem">
            {{ origenItem }}
          </option>
        </select>
        <div class="form-text">Indique el origen o procedencia de las plantas.</div>
      </div>


      <!-- Segunda fila -->
      <div class="col-md-6">
        <label for="codigo" class="form-label">codigos disponibles</label>
        <ul class="list-group" style="max-height: 150px; overflow-y: auto;">
          <li class="list-group-item" v-for="codigoDisponible in listacodigos" :key="codigoDisponible">
            {{ codigoDisponible }}
          </li>
        </ul>
      </div>

      <div class="col-md-6">
        <label for="fecha_inicio" class="form-label">Fecha de Creacion:</label>
        <input type="date" v-model="fecha_inicio" class="form-control" required>
      </div>

      <!-- Tercera fila para el botón -->
      <div class="col-md-12 d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-secondary ms-2" @click="cancelarAccion">Cancelar</button>
        <button type="submit" class="btn btn-primary">Agregar Plantas</button>
      </div>
    </form>



    <div class="modal fade show d-block" tabindex="-1" role="dialog" v-if="mostrarModalGenetica"
      style="background-color: rgba(0, 0, 0, 0.5)">
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content shadow-sm">
          <!-- Header -->
          <div class="modal-header bg-dark text-white">
            <h5 class="modal-title">
              <font-awesome-icon :icon="['fas', 'dna']" class="me-2" />
              Alta de Nueva Genética
            </h5>
            <button type="button" class="btn-close btn-close-white" @click="mostrarModalGenetica = false"></button>
          </div>

          <!-- Body -->
          <div class="modal-body bg-light">
            <AltaGenetica :club_id="club_id" @accionTerminada="onGeneticaCreada"
              @close="mostrarModalGenetica = false" />
          </div>

          <!-- Footer -->
          <div class="modal-footer">
            <button class="btn btn-outline-secondary" @click="mostrarModalGenetica = false">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>
import axios from '@/axios';
import AltaGenetica from '../Genetica/alta-genetica.vue';

export default {
  name: 'AltaPlantaLote',
  components: {
    AltaGenetica,
  },
  props: {
    lote_id: {
      type: Number,
      required: true,
    },
    club_id: {
      type: Number,
      required: true,
    },
  },
  computed: {
    codigosDisponibles() {
      // Utiliza el método para generar codigos disponibles
      return this.generarcodigosDisponibles();
    },
  },
  data() {
    return {
      mostrarModalGenetica: false,

      codigo: '',
      fecha_inicio: this.obtenerFechaActual(), // Inicializa con la fecha actual
      variedad_id: null,
      cantidad: 1,
      origen: '', // Nuevo campo para el origen de la planta
      variedades: [], // Se cargan las variedades disponibles desde el servidor
      origenes: [], // Se cargarán los orígenes disponibles desde el endpoint
      clubActual: this.$store.getters.getClubActual,
      proyectoActual: this.$store.getters.getProyectoActual,
      cantidadPlantasLote: 0,
      listacodigos: [],
      mostrarAltaGenetica: false,
      geneticaCreadaId: null,

    };
  },
  watch: {
    cantidad() {
      this.generarcodigosDisponibles();
    },
    variedad_id() {
      this.generarcodigosDisponibles();
    }
  },
  methods: {
    async agregarPlantas() {
      try {

        if (this.cantidadPlantasLote + this.cantidad > 200) {
          const cantidadDisponible = 200 - this.cantidadPlantasLote;
          alert(`No se pueden agregar más de 200 plantas en un lote el cual ya tiene ${this.cantidadPlantasLote} Plantas. Solo puedes agregar ${cantidadDisponible} plantas`);
          return;
        }
        //validar que haya lista de codigos
        if (this.listacodigos.length === 0 || this.listacodigos[0] === "No hay codigos disponibles" || this.listacodigos[0] === "Error al obtener codigos") {
          alert("No hay códigos disponibles para asignar a las plantas. Por favor, genere códigos primero. Pruebe con actualizar la cantidad de plantas.");
          return;
        }

        const response = await axios.post(`/api/planta/agregar-varias`, {
          form: {
            fecha_inicio: this.fecha_inicio,
            variedad_id: this.variedad_id,
            cantidad: this.cantidad,
            origen: this.origen, // Se envía el origen de la planta
            lote_id: this.lote_id, // Asegúrate de enviar el lote_id al servidor
            listacodigos: this.listacodigos,
          },
          club_id: this.club_id
        });

        if (response.status === 200) {
          alert('Plantas agregadas correctamente');
          this.resetearCampos();
          this.$emit('plantas-creadas');
          this.$emit('close');
        } else {
          alert('Ocurrió un error al agregar las plantas');
        }
      } catch (error) {
        console.error('Error al agregar plantas:', error);
      }
    },
    async cargarVariedades() {
      try {
        const response = await axios.get(`/api/geneticasPorClub/${this.club_id}`);
        this.variedades = response.data;
      } catch (error) {
        console.error('Error al cargar las variedades:', error);
      }
    },
    async cargarOrigenes() {
      try {
        const response = await axios.get('/api/constantes/origen_planta');
        // Se asume que el endpoint retorna un arreglo de strings. Si retorna objetos, ajustar aquí.
        this.origenes = response.data;
      } catch (error) {
        console.error('Error al cargar los orígenes:', error);
      }
    },
    // Método para generar codigos disponibles
    async generarcodigosDisponibles() {
      if (this.cantidad > 0) {
        try {
          const resultado = await axios.get(`/api/planta_generar_codigos`, {
            params: {
              cantidad: this.cantidad,
              lote_id: this.lote_id,
              club_id: this.clubActual.id
            }
          });

          this.listacodigos = resultado.data?.length ? resultado.data : ["No hay codigos disponibles"];

        } catch (error) {
          console.error("Error generando codigos disponibles", error);
          this.listacodigos = ["Error al obtener codigos"];
        }
      } else {
        this.listacodigos = ["No hay codigos disponibles"];
      }
    },
    obtenerFechaActual() {
      const hoy = new Date();
      const formatoFecha = hoy.toISOString().split('T')[0];
      return formatoFecha;
    },
    resetearCampos() {
      this.codigo = '';
      this.fecha_inicio = this.obtenerFechaActual();
      this.variedad_id = null;
      this.cantidad = 1;
      this.origen = '';
    },
    cancelarAccion() {
      this.resetearCampos();
      this.$emit('cancelar-accion');
      this.$emit('close');
    },
    async obtenerCantidadPlantasDelLote() {
      try {
        const response = await axios.get(`/api/planta/cantidad-plantas-lote/${this.lote_id}`);

        this.cantidadPlantasLote = response.data;
      } catch (error) {
        console.error('Error al obtener la cantidad de plantas del lote:', error);
      }
    },
    async onGeneticaCreada() {
      this.mostrarModalGenetica = false;
      await this.cargarVariedades();
      // Opcionalmente, podés seleccionar la última genética creada automáticamente:
      const ultima = this.variedades[this.variedades.length - 1];
      if (ultima) {
        this.variedad_id = ultima.id;
        await this.generarcodigosDisponibles();

      }
    },

  },
  mounted() {



    this.cargarVariedades();
    this.cargarOrigenes();
    this.obtenerCantidadPlantasDelLote();
  },
};
</script>

<style scoped>
/* Estilos específicos para tu componente */
.scrollable-dropdown {
  max-height: 150px;
  overflow-y: auto;
}

.view3-wrapper {
  border: 1px solid #ccc;
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}
</style>